import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatRadioModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatListModule,
  MatButtonToggleModule
} from '@angular/material';

import { LayoutModule } from '@core/layout';
import { InputImagesModule } from '@ui/input-images';
import { ConfirmationDialogModule } from '@ui/confirmation-dialog';
import { InputFileModule } from '@ui/input-file';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { UserPersonalDataComponent } from './pages/user-personal-data/user-personal-data.component';
import { UserInformationComponent } from './components/personal-data/user-information/user-information.component';
import { UserInformationEditComponent } from './components/personal-data/user-information-edit/user-information-edit.component';
import { UserPassportComponent } from './components/personal-data/user-passport/user-passport.component';
import { UserDrivingLicenseComponent } from './components/personal-data/user-driving-license/user-driving-license.component';
import { UserTractionCarsComponent } from './components/personal-data/user-traction-cars/user-traction-cars.component';
import { ModalAddTractionCarComponent } from './components/modal-add-traction-car/modal-add-traction-car.component';
import { UserActiveDealsComponent } from './pages/user-active-deals/user-active-deals.component';
import { ModalReturnTrailerComponent } from './components/modal-return-trailer/modal-return-trailer.component';
import { UserActiveTransferActComponent } from './pages/user-active-transfer-act/user-active-transfer-act.component';
import { UserActiveReturnActComponent } from './pages/user-active-return-act/user-active-return-act.component';
import { UserNewDealComponent } from './pages/user-new-deal/user-new-deal.component';
import { UserNewPickTrailerMapComponent } from './pages/user-new-pick-trailer-map/user-new-pick-trailer-map.component';
import { UserArchiveDealsComponent } from './pages/user-archive-deals/user-archive-deals.component';
import { ToastModule } from '@ui/toast';
import { FieldPhoneNumberInputModule } from '@ui/field-phone-number-input';
import { UploadDocumentPhotoModule } from '@ui/upload-document-photo';
import { UiErrorsModule } from '@ui/ui-errors';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { environment } from '../../../environments/environment';
import { MapComponent } from './components/map/map.component';
import { TrailerListComponent } from './components/trailer-list/trailer-list.component';
import {LocationsListComponent} from "@accounts/user/components/locations-list/locations-list.component";
import {FiltersListComponent} from "@accounts/user/components/filters-list/filters-list.component";
import { ModalTariffListComponent } from './components/modal-tariff-list/modal-tariff-list.component';
import { ModalStationListComponent } from '@accounts/user/components/modal-station-list/modal-station-list.component';
import { TrailerPipe } from '@accounts/user/components/trailer-list/trailer-list.component';
import { ComponentsModule } from '@core/components';
import { OrderCardComponent } from './components/order-card/order-card.component';
import { OrderCardDetailsComponent } from './components/order-card-details/order-card-details.component';
import { GridViewModule } from '@ui/grid-view';
import { ListItemDirective } from '@ui/grid-view/custom-template-view/custom-template-view.component';
import { UserDealsListComponent } from './components/deals-list/deals-list.component';
import { ModalDefectsListComponent } from '@accounts/user/components/modal-defects-list/modal-defects-list.component';
import { GalleryModule } from '@ngx-gallery/core';
import { ModalPersonalDataComponent } from '@accounts/user/components/modal-personal-data/modal-personal-data.component';
import { SearchAddressComponent } from './components/search-address/search-address.component';
import {UserInfoComponent} from "@accounts/user/pages/user-info/user-info.component";
import {SupportComponent} from "@accounts/user/pages/support/support.component";
import {ModalConfirmationCodeComponent} from "@accounts/user/components/modal-confirmation-code/modal-confirmation-code.component";
import {ModalTermsComponent} from "@accounts/user/components/modal-terms/modal-terms.component";
import {ModalRentalPanelComponent} from "@accounts/user/components/modal-rental-panel/modal-rental-panel.component";
import {RentalDetailComponent} from "@accounts/user/pages/rental-detail/rental-detail.component";
import {FinishRentComponent} from "@accounts/user/components/finish-rent/finish-rent.component";
import {TrailerReserveDoneComponent} from "@accounts/user/components/trailer-reserve-done/trailer-reserve-done.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {
  UserSelectReturnStationComponent
} from "@accounts/user/components/user-select-return-station/user-select-return-station.component";
import {NgxMaskModule} from "ngx-mask";
import { PdfViewerPageModule } from '@ui/pdf-viewer-page/pdf-viewer-page.module';

@NgModule({
  declarations: [
    UserComponent,
    UserPersonalDataComponent,
    UserInformationComponent,
    UserInformationEditComponent,
    UserPassportComponent,
    UserDrivingLicenseComponent,
    UserTractionCarsComponent,
    UserActiveDealsComponent,
    UserActiveTransferActComponent,
    UserActiveReturnActComponent,
    UserNewDealComponent,
    UserNewPickTrailerMapComponent,
    UserArchiveDealsComponent,
    ModalAddTractionCarComponent,
    ModalReturnTrailerComponent,
    MapComponent,
    TrailerListComponent,
    ModalTariffListComponent,
    ModalStationListComponent,
    TrailerPipe,
    OrderCardComponent,
    OrderCardDetailsComponent,
    ListItemDirective,
    UserDealsListComponent,
    ModalDefectsListComponent,
    ModalPersonalDataComponent,
    SearchAddressComponent,
    UserInfoComponent,
    SupportComponent,
    ModalConfirmationCodeComponent,
    ModalTermsComponent,
    ModalRentalPanelComponent,
    RentalDetailComponent,
    FinishRentComponent,
    TrailerReserveDoneComponent,
    LocationsListComponent,
    FiltersListComponent,
    UserSelectReturnStationComponent,
  ],
  entryComponents: [
    ModalAddTractionCarComponent,
    ModalReturnTrailerComponent,
    ModalDefectsListComponent,
    ModalPersonalDataComponent,
    ModalTermsComponent,
    ModalRentalPanelComponent,
    TrailerListComponent,
    FinishRentComponent,
    TrailerReserveDoneComponent,
    LocationsListComponent,
    FiltersListComponent,
    UserSelectReturnStationComponent,
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    InputFileModule,
    InputImagesModule,
    ConfirmationDialogModule,
    FieldPhoneNumberInputModule,
    UploadDocumentPhotoModule,
    UiErrorsModule,
    ToastModule,
    ComponentsModule,
    GridViewModule,
    GalleryModule,
    Angular2PromiseButtonModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey
    }),

    /* mat modules */
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatCardModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatListModule,
    MatButtonToggleModule,
    MatExpansionModule,
    NgxMaskModule,
    PdfViewerPageModule,
    /* end mat modules */
  ],
  providers: [
    GoogleMapsAPIWrapper
  ],
    exports: [
        ModalPersonalDataComponent,
        TrailerListComponent,
        LocationsListComponent,
        FiltersListComponent,
        UserSelectReturnStationComponent,
    ]
})
export class UserModule { }
